module.exports = __webpack_public_path__ + "static/media/detail_Pulmonary_pg1.8025223e.png";